"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUrlParams = exports.getRoomOccupancy = exports["default"] = exports.createMobilePayload = exports.MOBILE_PROVIDERS = exports.AA_DATE_FORMAT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _AaPassengerRoomSelection = require("../../components/containers/airasia-room-selection-container/AaPassengerRoomSelection.model");

var _AaHelpers = require("../AaHelpers");

var _EnvironmentUrl = _interopRequireDefault(require("../../config/environment/EnvironmentUrl"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DEFAULT_AGES = {
  CHILD: 17,
  INFANT: 1
};
var SEPARATORS = {
  CHILD: ',',
  ADULT: ',',
  ROOM: '_',
  SEARCH_QUERY: '?',
  QUERY_PARAM: '&',
  KEY_VALUE: '='
};
var AA_DATE_FORMAT = 'yyyy-MM-dd';
exports.AA_DATE_FORMAT = AA_DATE_FORMAT;
var HOTEL_PATH = 'HOTEL_LIST';
var MOBILE_PROVIDERS = {
  AAGO: 'AAGO',
  WEB: 'SNAP_WEB'
};
exports.MOBILE_PROVIDERS = MOBILE_PROVIDERS;
var Providers = MOBILE_PROVIDERS.AAGO | MOBILE_PROVIDERS.WEB;

var createMobilePayload = function createMobilePayload(provider, directDeeplink) {
  return {
    searchMetadata: {
      snapProvider: provider,
      directDeeplink: directDeeplink
    }
  };
};

exports.createMobilePayload = createMobilePayload;

function searchUrlBuilder(environment) {
  // eslint-disable-next-line prettier/prettier
  var _EnvironmentUrl$envir = _EnvironmentUrl["default"][environment],
      AA_HOTEL_SEARCH_PATH_PARAMETERS = _EnvironmentUrl$envir.AA_HOTEL_SEARCH_PATH_PARAMETERS,
      AA_BASE_URL = _EnvironmentUrl$envir.AA_BASE_URL;

  var formatChildComponent = function formatChildComponent(room, index) {
    var childCount = room.child,
        infantCount = room.infant,
        childAges = room.childAges;
    var roomNumber = index + 1;
    var children = [];

    for (var i = 0; i < childCount; i += 1) {
      var age = DEFAULT_AGES.CHILD;

      if (childAges && childAges[i] && childAges[i].value) {
        age = childAges[i].value;
      }

      children.push("".concat(roomNumber).concat(SEPARATORS.ROOM).concat(age));
    }

    return [].concat(children).join(SEPARATORS.CHILD);
  };

  var formatChildParam = function formatChildParam(room, index) {
    var childComponent = formatChildComponent(room, index);
    return encodeURIComponent(childComponent);
  };

  var createPathParameters = function createPathParameters(searchParams) {
    var rooms = searchParams.rooms,
        tripDates = searchParams.tripDates,
        destination = searchParams.destination;
    var childParam = rooms.map(formatChildParam).join(SEPARATORS.CHILD);
    return {
      '{locale}': searchParams.locale,
      '{destination}': destination.id,
      '{location}': encodeURIComponent(destination.full_name),
      '{adult}': rooms.map(function (room) {
        return room.adult;
      }).join(SEPARATORS.ADULT),
      '{child}': childParam,
      '{countryCode}': searchParams.countryCode,
      '{currency}': searchParams.currency,
      '{checkinDate}': (0, _format["default"])(tripDates.checkinDate, AA_DATE_FORMAT),
      '{checkoutDate}': (0, _format["default"])(tripDates.checkoutDate, AA_DATE_FORMAT)
    };
  };

  var AGENT_ID_PARAM = 'agent';

  var getAgentIdSection = function getAgentIdSection(agentId) {
    if (!agentId) {
      return '';
    }

    return "&".concat(AGENT_ID_PARAM, "=").concat(agentId);
  };

  var build = function build(searchParams) {
    var paramsToReplace = createPathParameters(searchParams);
    var substitutedPathParams = (0, _AaHelpers.substituteValues)(AA_HOTEL_SEARCH_PATH_PARAMETERS, paramsToReplace);
    var agentIdSection = getAgentIdSection(searchParams.agentId);
    return "".concat(AA_BASE_URL).concat(substitutedPathParams).concat(agentIdSection);
  };

  var buildMobileProps = function buildMobileProps(searchParams) {
    var tripDates = searchParams.tripDates,
        destination = searchParams.destination,
        rooms = searchParams.rooms,
        currency = searchParams.currency,
        locale = searchParams.locale,
        countryCode = searchParams.countryCode; // console.log("@@@ searchParams",searchParams);
    // const childrenParam = rooms.map((room) => [
    //     ...Array(room.child).fill(DEFAULT_AGES.CHILD),
    //     // ...Array(room.infant).fill(DEFAULT_AGES.INFANT),
    // ]);

    var childrenParam = rooms.map(function (room) {
      var _room$childAges = room.childAges,
          childAges = _room$childAges === void 0 ? [] : _room$childAges,
          child = room.child;
      var childAgeArr = [];

      for (var i = 0; i < child; i++) {
        if (childAges[i]) {
          childAgeArr.push(childAges[i].value);
        } else {
          childAgeArr.push(DEFAULT_AGES.CHILD);
        }
      }

      return childAgeArr;
    });
    return {
      path: HOTEL_PATH,
      checkin: (0, _format["default"])(tripDates.checkinDate, AA_DATE_FORMAT),
      checkout: (0, _format["default"])(tripDates.checkoutDate, AA_DATE_FORMAT),
      locationId: destination.id,
      location: destination.name,
      roomsCount: rooms.length,
      guest_adult: rooms.map(function (room) {
        return room.adult;
      }),
      guest_children: childrenParam,
      currency: currency,
      language: locale,
      country_code: countryCode
    };
  };

  var buildParams = function buildParams(searchParams) {
    var tripDates = searchParams.tripDates,
        destination = searchParams.destination,
        rooms = searchParams.rooms,
        currency = searchParams.currency,
        locale = searchParams.locale;
    var children = rooms.map(formatChildComponent).join(SEPARATORS.CHILD);
    var params = {
      checkin: (0, _format["default"])(tripDates.checkinDate, AA_DATE_FORMAT),
      checkout: (0, _format["default"])(tripDates.checkoutDate, AA_DATE_FORMAT),
      roomsCount: rooms.length,
      adults: rooms.map(function (room) {
        return room.adult;
      }).join(SEPARATORS.ADULT),
      children: children,
      currency: currency,
      language: locale
    };

    if (destination.id) {
      params.locationId = destination.id;
      params.location = destination.name;
    }

    if (destination.type === 'hotel' && destination.aa_id) {
      params.aaId = destination.aa_id;
    }

    return params;
  };

  return {
    build: build,
    buildMobileProps: buildMobileProps,
    buildParams: buildParams
  };
}

var parseArray = function parseArray(param, separator) {
  return param.split(separator).filter(Boolean);
};

var getChildComponents = function getChildComponents(childParam) {
  return parseArray(childParam, SEPARATORS.ROOM).map(Number);
};

var getRoomOccupancy = function getRoomOccupancy(adultsParam, childrenParam) {
  var adults = parseArray(adultsParam, SEPARATORS.ADULT).map(Number);
  var fullChildren = parseArray(childrenParam, SEPARATORS.CHILD).sort(function (childA, childB) {
    var _getChildComponents = getChildComponents(childA),
        _getChildComponents2 = (0, _slicedToArray2["default"])(_getChildComponents, 1),
        roomIndexA = _getChildComponents2[0];

    var _getChildComponents3 = getChildComponents(childB),
        _getChildComponents4 = (0, _slicedToArray2["default"])(_getChildComponents3, 1),
        roomIndexB = _getChildComponents4[0];

    return roomIndexA - roomIndexB;
  });
  var initialOccupancy = adults.map(function (adult) {
    return (0, _AaPassengerRoomSelection.buildRoomModel)(adult);
  });
  return fullChildren.reduce(function (result, child, index) {
    var _getChildComponents5 = getChildComponents(child),
        _getChildComponents6 = (0, _slicedToArray2["default"])(_getChildComponents5, 2),
        roomIndex = _getChildComponents6[0],
        age = _getChildComponents6[1];

    var room = result[roomIndex - 1] || (0, _AaPassengerRoomSelection.buildRoomModel)(adults[index] || 0);

    if (age <= DEFAULT_AGES.INFANT) {
      room.infant += 1;
    } else if (age <= DEFAULT_AGES.CHILD) {
      room.child += 1;
    }

    return [].concat((0, _toConsumableArray2["default"])(result.slice(0, roomIndex - 1)), [room], (0, _toConsumableArray2["default"])(result.slice(roomIndex)));
  }, initialOccupancy);
};

exports.getRoomOccupancy = getRoomOccupancy;

var parseUrlParams = function parseUrlParams() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var searchParams = url.split(SEPARATORS.SEARCH_QUERY).pop();
  var queryParams = searchParams.split(SEPARATORS.QUERY_PARAM).reduce(function (result, param) {
    var _param$split = param.split(SEPARATORS.KEY_VALUE),
        _param$split2 = (0, _slicedToArray2["default"])(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, key, decodeURIComponent(value)));
  }, {
    adults: '',
    children: ''
  });
  var roomOccupancy = getRoomOccupancy(queryParams.adults, queryParams.children);
  return {
    destination: queryParams.locationId,
    checkin: queryParams.checkin,
    checkout: queryParams.checkout,
    roomOccupancy: roomOccupancy
  };
};

exports.parseUrlParams = parseUrlParams;
var _default = searchUrlBuilder;
exports["default"] = _default;